import { getImageKitUrl } from "utils/cdn";

export const Images = {
    profile: "/images/profile.webp",
    bank: "/images/bank.webp",
    coin: "/images/coin.webp",
    homepageMastHead: "/images/home_banner.png",
    time: "/images/time.webp",
    earnings: "/images/earnings.webp",
    bag: "/images/bag.webp",
    referralProfile: "/images/referral_icon.webp",
    warning: "/images/warning.webp",
    redWarning: "/images/red_warning.webp",
    referSuccess: "/images/refer_success.webp",
};

export const RemoteImages = {
    referral: "referrals_icon_converted.avif",
    profile: "profile_icon_converted.avif",
    bank: "bank_icon_converted.avif",
    coin: "coin_icon_converted.avif",
    defaultAvatar: "default_avatar.avif",
    mainBackgroundBanner: "main_banner_background.avif",
    foodImIcon: "food_im_icon.avif",
    bagIcon: "bag_icon.avif",
    moneyIcon: "money_icon.avif",
    handshakeIcon: "handshake_icon.avif",
}   